import type { StaticEntityType } from "@config";
import { fluidClamp } from "@/shared";
import type { CSSProperties } from "react";
import { IconElement, IconWrapper } from "../styles/Icon.styled";
import type { EditorDataProps, EditorSlotsProps, IconProps } from "../types";
import Link from "./Link";

export const IconLibrary = ({
  entity,
  editorData,
  editorSlots,
}: {
  entity: StaticEntityType;
  editorData?: EditorDataProps;
  editorSlots?: EditorSlotsProps;
}) => {
  const { settings } = entity as StaticEntityType<IconProps>;
  const fontSize = Number(editorData?.fontSize || settings.fontSize);
  // Guard against a non-numeric fontSize (e.g. an empty/units value) producing
  // an invalid clamp(); omit the var so CSS falls back to the inherited size.
  const fluidSize = Number.isFinite(fontSize)
    ? fluidClamp(fontSize)
    : undefined;

  return (
    <IconWrapper
      className="tw-relative"
      $horizontalAlignment={settings.horizontalAlignment}
    >
      <Link settings={settings}>
        <div
          className="iconSizeContainer tw-relative tw-flex [align-items:inherit] [justify-content:inherit]"
          onDoubleClick={editorData?.handleMediaChange}
          style={
            (fluidSize ? { "--entity-size": fluidSize } : {}) as CSSProperties
          }
        >
          {editorSlots?.resizeSlot}
          {settings.icon.startsWith("ri-") ? (
            <IconElement
              {...EDITOR_ATTRIBUTES({ isEditor: !!editorData })}
              as="i"
              $color={settings.color}
              className={settings.icon}
            />
          ) : settings.icon.startsWith("fa-") ? (
            <IconElement
              {...EDITOR_ATTRIBUTES({ isEditor: !!editorData })}
              as="i"
              $color={settings.color}
              className={`fa-solid ${settings.icon}`}
            />
          ) : (
            <IconElement
              className="material-icons"
              {...EDITOR_ATTRIBUTES({ isEditor: !!editorData })}
              $color={settings.color}
            >
              {settings.icon}
            </IconElement>
          )}
        </div>
      </Link>
      {!!settings.linkUrl && editorSlots?.pdfLinkToSrcSlot}
    </IconWrapper>
  );
};

const EDITOR_ATTRIBUTES = ({ isEditor }: { isEditor: boolean }) => {
  const payload: Record<string, string> = {
    "data-dnd-trigger": "true",
  };
  return isEditor ? payload : {};
};
